"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CompassOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25.9,6.1A14,14,0,1,0,30,16,13.94,13.94,0,0,0,25.9,6.1ZM24.49,24.49A12,12,0,1,1,28,16,12,12,0,0,1,24.49,24.49Z"/><path d="M12.2,12.21,21,14.51l-3.78,1.66-.71.31-.31.71L14.51,21,12.2,12.21M11.49,10a1.55,1.55,0,0,0-1.06.44,1.52,1.52,0,0,0-.38,1.42l2.9,11A1.49,1.49,0,0,0,14.29,24h.1a1.49,1.49,0,0,0,1.38-.93L18,18l5.07-2.23A1.49,1.49,0,0,0,22.9,13l-11-2.9a1.57,1.57,0,0,0-.37-.05Z"/>';
var CompassOutlineSVG = function CompassOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CompassOutlineSVG = CompassOutlineSVG;
CompassOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CompassOutlineSVG);
exports.default = _default;